import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { routes } from '@app/consts/routes';
import { features } from '@app/consts';
import { TranslateService } from '@ngx-translate/core';
import { FeatureService } from '@app/core/services/feature.service';
import { modules } from '@app/consts/modules';
import { ModuleConfigurationService } from '@app/core/services/module-configuration/module-configuration.service';

@Component({
  selector: 'app-time-off-section',
  templateUrl: './time-off-section.component.html',
  styleUrls: ['./time-off-section.component.scss']
})
export class TimeOffSectionComponent implements OnInit {
    public routes: typeof routes = routes;
    navList = [
        {
            text: 'TimeOff',
            link: `${routes.TIME_OFF}${routes.TIME_OFF}`,
            icon: 'alarm',
            featureCode: features.TIME_OFF,
            module: modules.TIME_OFF
        },
        {
            text: 'TimeOffInLieu',
            link: `${routes.TIME_OFF}${routes.TOIL}${routes.TOIL_POLICIES}`,
            icon: 'work',
            featureCode: features.TOIL_ADMINISTRATION,
            module: modules.TOIL,
        },
        {
            text: 'StatutoryHolidays',
            link: `${routes.TIME_OFF}${routes.STATUTORY_HOLIDAYS}`,
            icon: 'wb_sunny',
            featureCode: features.TIME_OFF,
            module: modules.TIME_OFF
        },
        {
            text: 'BuySell',
            link: `${routes.TIME_OFF}${routes.BUY_SELL}`,
            icon: 'shopping_cart',
            featureCode: features.BUY_SELL,
            module: modules.TIME_OFF
        }
    ];

    constructor(
        public translate: TranslateService,
        public router: Router,
        private featureService: FeatureService,
        private moduleConfigurationService: ModuleConfigurationService,
    ) {
    }

    ngOnInit(): void {
        this.removeFeaturesWithoutModuleAccess();
        this.navigateToFirstAllowedSection();
    }

    // If the client doesnt have access to a module remove it form the list
    removeFeaturesWithoutModuleAccess() {
        this.navList = this.navList.filter(
            feature => {
                if(feature.module) {
                    return this.moduleConfigurationService.hasModuleAccess(feature.module);
                }
                else {
                    return true;
                }
            }
        )
    }

    navigateToFirstAllowedSection() {
        let urlToNavigateTo = '';

        if(this.router.url === `${routes.TIME_OFF}`) {
          this.navList.every(element => {
            let hasAccess = this.featureService.hasFeatureAccess(element.featureCode)

            if(hasAccess){
              urlToNavigateTo = element.link;
              return false;
            }

            return true;
          });
        }

        if(urlToNavigateTo !== ''){
          this.router.navigate([urlToNavigateTo]);
        }
    }
}
